export const getAskDemos = (state) => state.ask_demos
export const getAskDemosMeta = (state) => state.meta_data
export const getAskDemoStatus = (state) => state.status